<script setup>
import { ref, watch, defineEmits, defineProps, nextTick } from 'vue'
import gen from '@/functions/general'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  sapConcept: { type: Object, default: null }
})
const emits = defineEmits(['savePrescriptionDuration'])

const prescriptionDuration = ref('DefaultDuration')
const customDurationDays = ref('')
const customDurationRef = ref(null)

watch(() => props.sapConcept, (val) => {
  prescriptionDuration.value = val?.pharmacyPrescriptionType || 'DefaultDuration'
  customDurationDays.value = val?.customPrescriptionDays?.toString() || ''
}, { immediate: true })

function onPrescriptionDurationUpdate() {
  if (prescriptionDuration.value === 'CustomDuration' && !parseInt(customDurationDays.value)) {
    prescriptionDuration.value = 'DefaultDuration'
  }
  emits('savePrescriptionDuration', {
    conceptGroupId: props.sapConcept?.conceptGroupId,
    prescriptionDuration: prescriptionDuration.value,
    customDurationDays: prescriptionDuration.value === 'CustomDuration'
      ? (parseInt(customDurationDays.value) || null)
      : null
  })
}

function selectCustom() {
  prescriptionDuration.value = 'CustomDuration'
  nextTick(() => {
    customDurationRef.value?.$el?.focus()
    customDurationRef.value?.$el?.select()
  })
}
</script>

<template>
  <div class="bg-modal w-maxC">
    <text-item :txt="t('patient.pharmacy.title')" styles="font-mBold" class="mleft-02"/>
    <div class="col gap-01 mtop-10">
      <div class="row-center gap-08">
        <switchGroup :active="prescriptionDuration === 'DefaultDuration'" @click="prescriptionDuration = 'DefaultDuration'; onPrescriptionDurationUpdate()">
          <svg-item icon="check" styles="size-m" :class="prescriptionDuration === 'DefaultDuration' ? 'img-white' : ''"/>
        </switchGroup>
        <text-item :txt="t('patient.pharmacy.DefaultDuration')"/>
      </div>
      <div class="row-center gap-08">
        <switchGroup :active="prescriptionDuration === 'CustomDuration'" @click="selectCustom">
          <svg-item icon="check" styles="size-m" :class="prescriptionDuration === 'CustomDuration' ? 'img-white' : ''"/>
        </switchGroup>
        <text-item :txt="t('patient.pharmacy.CustomDuration')"/>
        <div class="row-center mleft-08">
          <inputBox style="width: 3.5rem;">
            <inputLineNew2 ref="customDurationRef" v-model="customDurationDays"
              @keydown="gen.onlyNumber"
              @focus="prescriptionDuration = 'CustomDuration'"
              @blur="onPrescriptionDurationUpdate"
            />
          </inputBox>
          <text-item :txt="t('patient.pharmacy.customDurationDays')" class="mleft-08 main-h"/>
        </div>
      </div>
      <div class="row-center gap-08">
        <switchGroup :active="prescriptionDuration === 'NotForPharmacy'" @click="prescriptionDuration = 'NotForPharmacy'; onPrescriptionDurationUpdate()">
          <svg-item icon="check" styles="size-m" :class="prescriptionDuration === 'NotForPharmacy' ? 'img-white' : ''"/>
        </switchGroup>
        <text-item :txt="t('patient.pharmacy.NotForPharmacy')"/>
      </div>
    </div>
  </div>
</template>